import { useCallback, useReducer, useRef, useState } from "react";
import { ApiConnector, setToken } from "common/ApiConnector";
import { App } from "antd";

const url_endpoint = "api/v1";

export const useInstances = (cat_user_id) => {
    const { modal } = App.useApp();
    const [info, setInfo] = useState({});
    const [nodeStatus, setNodeStatus] = useState(info.status ?? "STOPPED");
    const [updatingCheckbox, setUpdatingCheckbox] = useState(false);

    const updateToken = async () => {
        await setToken(atob(cat_user_id));
    }

    const getInfo = async () => {
        let res = await ApiConnector.get(`${url_endpoint}/instance-info`);
        setInfo(res.data);
        return res.data;
    }

    const start_node = async () => {
        await ApiConnector.get(`${url_endpoint}/instance-start`);
    }

    const stop_node = async () => {
        await ApiConnector.get(`${url_endpoint}/instance-stop`);
    }

    const starting_node = async () => {
        setNodeStatus("STARTING");

        await start_node();
        console.info("Finalizado.");
    }

    const reset_node = async () => {
        let res_modal = await modal.confirm({
            content: "Los datos de sesión del bot se eliminarán. ¿Continuar?"
        });
        if(res_modal) {
            await ApiConnector.get(`${url_endpoint}/instance-reset`);
        }
    }

    const ws = useRef();
    const connectWS = (code) => {
        try {

            if(!ws.current) {
                ws.current = new WebSocket(`wss://was2.myquickone.com/client`);
                ws.current.onopen = () => {
                    console.log('WebSocket connected');
                };

                ws.current.onmessage = (event) => {
                    console.log(`onmessage: ${event.data}`);
                    let data = JSON.parse(event.data);

                    if(data.type === "req_system" && data.command === "send_info") {
                        ws.current.send(JSON.stringify({
                            command: "send_info",
                            response: {
                                type: "client",
                                node_id: code
                            }
                        }));
                    }

                    if(data.type === "info_status") {
                        let {qr, status, auth_status} = data.response;
                        setInfo(prev => ({...prev, qr: qr, status: status, auth_status: auth_status}));
                    }
                };

                ws.current.onclose = () => {
                    console.log('WebSocket disconnected');
                };

                ws.current.onerror = (error) => {
                    console.error('WebSocket error:');
                };
            }

        } catch (error) {
            console.log(error);
        }

    }

    const disconnectWS = () => {
        if(ws.current) {
            ws.current.close();
        }
    }

    const updateKeepOnline = async (value) => {
        try {
            setUpdatingCheckbox(true);
            let res = await ApiConnector.post(`${url_endpoint}/update-keep-online` ,{
                keep_online: value,
            });
            setInfo(res.data);
            // getInfo();
        } catch (error) {
        } finally { setUpdatingCheckbox(false); }
    }

    return {
        updateToken,
        getInfo,
        info,
        node: {
            status: nodeStatus,
            start: starting_node,
            stop: stop_node,
            reset: reset_node,
            updateKeepOnline: updateKeepOnline,
            updatingCheckbox
        },
        WSock: {
            connect: connectWS,
            disconnect: disconnectWS,
            socket: ws.current
        }
    };
}
